import type { ReactNode } from 'react';
import React, { forwardRef } from 'react';

import { FormControlLabel, Radio } from '@mui/material';

import { RadioButtonCheckedIcon, RadioButtonIcon } from './MuiRadioButton.style';

import type { RadioProps } from '@mui/material';

export type ColorType = 'primary' | 'secondary';
type MuiRadioButtonProps = {
  isDisabled?: boolean;
  checked?: boolean;
  value?: string | boolean;
  label?: string | ReactNode;
  isError?: boolean;
  color?: ColorType;
} & Partial<Omit<RadioProps, 'label' | 'color'>>;

export const MuiRadioButton = forwardRef<HTMLHeadingElement, MuiRadioButtonProps>((props, ref) => {
  const { isDisabled, checked, label, isError = false, size = 'medium', color = 'primary', ...args } = props;

  return (
    <FormControlLabel
      ref={ref}
      control={
        <Radio
          {...args}
          checked={checked}
          disabled={isDisabled}
          color="default"
          checkedIcon={<RadioButtonCheckedIcon isError={isError} size={size} color={color} />}
          icon={<RadioButtonIcon isError={isError} size={size} color={color} />}
        />
      }
      label={label}
    />
  );
});
